import styled from "styled-components";

export const StyledLine = styled.div`
  border-bottom: ${({ theme }) => {
    return `2px solid ${theme.colors.green};`;
  }};
  width: ${({ width }) => {
    return `${width}px;`;
  }};
  margin-left: 7px;
`;

export const DashLineContainer = styled.div`
  width: fit-content;
  margin: auto;
  height: fit-content;
  padding: 0px;
  margin-top: 20px;
`;
